import { faxModalStateDefault } from '~/atoms/ModalState'

import { FaxSendingStep } from './enums'
import type {
  CacheEmailConfirmations,
  State,
  StateJotai,
  StateReact,
} from './types'

export const cacheEmailConfirmationsDefault: CacheEmailConfirmations = {
  emails: [],
  enabled: false,
}

export const stateJotaiDefault: StateJotai = {
  emailConfirmations: [],
  faxSendingProgress: 0,
  faxSendingStep: FaxSendingStep.NotStarted,
  fromNumber: '',
  phoneNumberListState: {
    data: [],
    hasNextPage: false,
    nextPageOffset: 0,
    search: '',
  },
  resendId: faxModalStateDefault.resendId,
  selectedFiles: [],
  selectedPhoneNumber: null,
  sendEmailConfirmation: false,
  toNumber: '',
}

export const stateReactDefault: StateReact = {
  lastUsedFaxNumber: null,
}

export const stateDefault: State = {
  ...stateJotaiDefault,
  ...stateReactDefault,
}
